import { BiCalendarAlt } from "react-icons/bi"; 
import { MdClear } from "react-icons/md"; 
import React, { useState, useImperativeHandle } from "react";
import TextField from '@material-ui/core/TextField';
import InputMask from 'react-input-mask';
import '../../styles/main.css';
// eslint-disable-next-line
import * as FxLog from '../fx/FxLog';
import * as FxDat from '../fx/FxDat';
import CxDlgCalendar from './CxDlgCalendar';
import CxIconButtonNew from './CxIconButtonNew';
import CxSnackbar from './CxSnackbar';
import { useStyles } from "./StylesCx";
import i18n from '../../i18n';
import * as FxControl from '../fx/FxControl';
import { useTranslation } from '../hx/useTranslation';

function InputFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <InputMask
      {...other}
      style={{
        border: 'none',
        outline: 'none',
        fontSize: 'var(--ibs_control_text_font_size)',
        width: '100px',
        margin: '0px 0px 0px 0px',
        color: props.disabled ? '#9E9E9E' : 'var(--ibs_color_black)',
      }}
      ref={props.inputRef}
      mask="99-99-9999"
      maskPlaceholder={FxDat.getDateFormat().toLowerCase()}
      value={props.value}
      onChange={props.onChange}
    />
  );
}

const CxDate = props => {
  const [{ trans }] = useTranslation();
  const classes = useStyles(props);
  // Se incluye minDateRef para la validación cruzada
  const { onBlur, onClear, onChangeDate, InputLabelProps, InputProps, defaultValue, showAge, today, todayAdd, fromYear2000, label, labelTooltip, minDateRef, ...rest } = props;
  const [myValue, setMyValue] = useState('');
  const [myLabel, setMyLabel] = useState(label);
  const [myAge, setMyAge] = useState('');
  const [isRequired, setIsRequired] = useState(false);
  const [wasChanged, setChanged] = React.useState(false);
  const [dlg, setDlg] = React.useState(false);
  const [visible, setVisible] = React.useState(props.visible === 'false' ? false : true);

  const r_dlg = React.useRef(null);
  const r_snack_error = React.useRef(null);

  const r_clearing = React.useRef(false);

  const rf_control = React.useRef(null);

  React.useEffect(() => {
    setIsRequired(props.required);
    if (defaultValue) {
      setVal(defaultValue);
    }
    if (today) {
      setValToday();
    }
    if (todayAdd) {
      setValTodayAdd(todayAdd);
    }
    if (fromYear2000) {
      setVal('2000-01-01');
    }
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (r_clearing.current) {
      r_clearing.current = false;
      if (onClear !== undefined) onClear();
    }
    // eslint-disable-next-line
  }, [myValue]);

  // para poder usar setVal desde el parent component con ref.current
  useImperativeHandle(props.xref, () => {
    return {
      getType, setVal, getVal, getIsRequired, getLabel, setLabel, getDbfield, setFocus, setFocusSel, isEmpty, clear, setValToday, setValTodayAdd,
      wasChanged, setChanged, setVisible,
    };
  });

  const setVal = (newValue) => {
    if (!newValue) {
      setMyValue('');
    } else {
      let yyyy = parseInt(newValue.substring(0, 4)).toString().padStart(4, '0');
      let MM = parseInt(newValue.substring(5, 7)).toString().padStart(2, '0');
      let dd = parseInt(newValue.substring(8, 10)).toString().padStart(2, '0');
      let dateFormat = FxDat.getDateFormat();
      if (dateFormat === 'MM-dd-yyyy') {
        setMyValue(`${MM}-${dd}-${yyyy}`);
      }
      if (dateFormat === 'dd-MM-yyyy') {
        setMyValue(`${dd}-${MM}-${yyyy}`);
      }
      if (showAge) {
        setMyAge(FxDat.getAge(newValue));
      }
    }
  };

  const getVal = () => {
    if (myValue === null) {
      return null;
    } else {
      // Devuelve la fecha en formato ISO (YYYY-MM-DD)
      return FxDat.toIsoDate(myValue); 
    }
  };

  const getIsRequired = () => {
    return isRequired && (getVal() === null || (getVal() || '').length === 0);
  };
  const getLabel = () => { return myLabel };
  const setLabel = (newText) => setMyLabel(newText);
  const getDbfield = () => { return props.dbfield };
  const setFocus = () => rf_control.current.focus();
  const setFocusSel = () => rf_control.current.select();
  const isEmpty = () => { return !myValue || myValue.length === 0 };
  const clear = () => { setMyValue(''); setChanged(true); };
  const getType = () => { return 'CxDate' };

  const setValToday = () => {
    let today = FxDat.todayInLocal();
    setMyValue(today);
  };

  const setValTodayAdd = (days) => {
    let next = FxDat.toLocalDate(FxDat.addDays(FxDat.getDateToday(), days));
    setMyValue(next);
  };

  const doClear = () => {
    r_clearing.current = true;
    setMyValue('');
    setMyAge('');
    setChanged(true);
    setFocusSel();
    if (onChangeDate !== undefined) onChangeDate('');
  }

  // Lógica para verificar contra la referencia externa
  const checkMinDateRef = (targetDateIso) => {
    // Si existe la ref y está definida
    if (minDateRef && minDateRef.current) {
      // Obtenemos el valor ISO del componente referenciado
      const minDateIso = minDateRef.current.getVal(); 
      // Si minDateIso existe y la fecha objetivo es menor
      if (minDateIso && targetDateIso < minDateIso) {
        // FxLog.warnx('CxDate', 'Fecha introducida anterior a la fecha mínima permitida.');
        return false; 
      }
    }
    return true; 
  };


  const doDateSelectedFromCalendar = (isoDateSelected) => {
    try {
      setDlg(false);
      if (isoDateSelected) {
        // Validación de rango
        if (!checkMinDateRef(isoDateSelected)) {
          // Si la fecha seleccionada es menor a la ref, ignoramos la selección.
          setMyValue(''); // Borramos si es menor a la fecha de referencia
          r_snack_error.current.setValAndOpen(trans('msg.date_from_later_than_date_to'));
          return; 
        }
        setVal(isoDateSelected);
        if (onChangeDate !== undefined) onChangeDate(isoDateSelected);
      }

    } catch (error) {
      FxLog.errorx('CxDate.doDateSelectedFromCalendar', error)
    }
  }

  const getLabelText = () => {
    if (showAge && myAge) {
      return `${myLabel} (${myAge})`;
    } else {
      return myLabel;
    }
  }

  return (
    <div className={classes.frame} style={{ display: visible ? '' : 'none' }}>
      <div className={classes.frame_content}>
        <TextField
          {...rest}
          inputRef={rf_control}
          className={classes.control}
          label={FxControl.getLabel(getLabelText(), isRequired, labelTooltip)}
          InputLabelProps={{
            required: false,
            classes: { root: classes.root, },
            shrink: true,
            ...InputLabelProps
          }}
          InputProps={{ //refers to the Input component
            inputComponent: InputFormatCustom,
            disableUnderline: true,
            required: false,
            classes: {
              root: classes.root,
            },
            ...InputProps
          }}
          value={myValue}
          onBlur={() => {
            if (props.onBlur !== undefined) props.onBlur(props.dbfield, myValue);
            
            const isoValue = FxDat.toIsoDate(myValue);
            FxLog.infox('CxDate.return', '...FxDat.toIsoDate(myValue):', isoValue);
            
            if (!FxDat.isValidDtIso(isoValue)) { // Si no es una fecha real, la borra.
              setMyValue('');
            } else {
              // Validamos usando la referencia al otro componente
              if (!checkMinDateRef(isoValue)) {
                setMyValue(''); // Borramos si es menor a la fecha de referencia
                r_snack_error.current.setValAndOpen(trans('msg.date_from_later_than_date_to'));
              }
            }
          }}
          onChange={(e) => {
            let newValue = e.target.value;
            setMyValue(newValue);
            if (onChangeDate !== undefined) onChangeDate(FxDat.toIsoDate(newValue));
          }}
          onFocus={event => {
            if (rest.autoselect) {
              setTimeout(() => { // El setTimeout con 0ms asegura que el select() ocurra después del render
                event.target.select();
              }, 0);
            }
          }}
          onKeyDown={() => setChanged(true)}
        />
      </div>

      {!props.hidebuttons && <div className={classes.frame_buttons}>
        <CxIconButtonNew icon={<MdClear fontSize={20} />} classType={classes.frame_icons_new} onClick={doClear} disabled={props.disabled} />
        <CxIconButtonNew icon={<BiCalendarAlt fontSize={20} />} classType={classes.frame_icons_new} onClick={() => setDlg(true)} disabled={props.disabled} />
      </div>}

      <CxDlgCalendar
        xref={r_dlg}
        open={dlg}
        onClose={(d) => doDateSelectedFromCalendar(d)}
        title={i18n.t('msg.select_x').replace('%s', i18n.t('field.date'))}
      />
      
      <CxSnackbar xref={r_snack_error} severity="error" />
    </div>
  );
};

// ¡Esta línea soluciona el ERROR de importación!
export default CxDate;
